"use client";

import "./globals.css";
import AppErrorFallback from "@components/molecules/AppErrorFallback";

export default function GlobalError(props: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html lang="en">
      <body>
        <AppErrorFallback error={props.error} source="global" />
      </body>
    </html>
  );
}
